/* tslint:disable */
/* eslint-disable */
/**
 * Neptune Backend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.8
 * Contact: 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PriceTierDTO
 */
export interface PriceTierDTO {
    /**
     * 
     * @type {number}
     * @memberof PriceTierDTO
     */
    upperAmount: number;
    /**
     * 
     * @type {number}
     * @memberof PriceTierDTO
     */
    unitPriceInCents: number;
    /**
     * 
     * @type {number}
     * @memberof PriceTierDTO
     */
    flatFeeInCents: number;
}

/**
 * Check if a given object implements the PriceTierDTO interface.
 */
export function instanceOfPriceTierDTO(value: object): value is PriceTierDTO {
    if (!('upperAmount' in value) || value['upperAmount'] === undefined) return false;
    if (!('unitPriceInCents' in value) || value['unitPriceInCents'] === undefined) return false;
    if (!('flatFeeInCents' in value) || value['flatFeeInCents'] === undefined) return false;
    return true;
}

export function PriceTierDTOFromJSON(json: any): PriceTierDTO {
    return PriceTierDTOFromJSONTyped(json, false);
}

export function PriceTierDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): PriceTierDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'upperAmount': json['upperAmount'],
        'unitPriceInCents': json['unitPriceInCents'],
        'flatFeeInCents': json['flatFeeInCents'],
    };
}

export function PriceTierDTOToJSON(value?: PriceTierDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'upperAmount': value['upperAmount'],
        'unitPriceInCents': value['unitPriceInCents'],
        'flatFeeInCents': value['flatFeeInCents'],
    };
}

